
import { Component, ModelSync, Prop, Vue } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton,
  },
})
export default class DangerDialog extends Vue {
  @ModelSync("value", "input")
  show!: boolean;

  @Prop({ default: "Achtung!" })
  title!: string;

  @Prop({ default: "Löschen" })
  dangerActionText!: string;

  onCancel() {
    this.show = false;
    this.$emit("cancel");
  }

  onConfirm() {
    this.show = false;
    this.$emit("confirm");
  }
}
